import type { AkimaResult, AkimaError } from "./types";
import { DEFAULT_ENDPOINT } from "./types";

export async function submitAssessment(options: {
  url: string;
  email: string;
  endpoint?: string;
  source?: string;
  privacyConsent?: boolean;
  emailFollowUpConsent?: boolean;
}): Promise<AkimaResult> {
  const endpoint = options.endpoint || DEFAULT_ENDPOINT;

  const body: Record<string, string | boolean> = {
    url: options.url,
    email: options.email,
    privacyConsent: options.privacyConsent ?? true,
    emailFollowUpConsent: options.emailFollowUpConsent ?? false,
  };
  if (options.source) {
    body.source = options.source;
  }

  const response = await fetch(endpoint, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(body),
  });

  if (!response.ok) {
    let errorData: AkimaError;
    try {
      const json = await response.json();
      errorData = {
        message: json.error || "Anfrage fehlgeschlagen",
        details: json.details,
      };
    } catch {
      errorData = { message: `HTTP ${response.status}: Anfrage fehlgeschlagen` };
    }
    throw errorData;
  }

  return (await response.json()) as AkimaResult;
}
